module.exports = __webpack_public_path__ + "static/smalltalks-0c2133950cd9c31a1485796a13f2a585.png";